"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleCard = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const S = __importStar(require("./CollapsibleCard.styles"));
const Atoms_1 = require("../../../../stages/Atoms");
if (react_native_1.Platform.OS === 'android' &&
    react_native_1.UIManager.setLayoutAnimationEnabledExperimental) {
    react_native_1.UIManager.setLayoutAnimationEnabledExperimental(true);
}
exports.CollapsibleCard = ({ headerText, descriptionText, cardText, CardIcon, onPress = () => { }, dropDownIconColor = 'black', accessibilityLabel, accessibilityHint, }) => {
    const [expanded, setExpanded] = react_1.useState(false);
    const spinAnimation = react_1.useRef(new react_native_1.Animated.Value(0)).current;
    const expandButton = () => {
        react_native_1.Animated.timing(spinAnimation, {
            useNativeDriver: true,
            toValue: expanded ? 0 : 1,
            duration: 100,
        }).start();
        react_native_1.LayoutAnimation.configureNext(react_native_1.LayoutAnimation.Presets.easeInEaseOut);
        setExpanded(!expanded);
    };
    const spin = spinAnimation.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '180deg'],
    });
    return (react_1.default.createElement(S.CardWrapper, null,
        react_1.default.createElement(S.ClosedCardWrapper, { border: !expanded, activeOpacity: 0.7, accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, accessibilityRole: "button", onPress: () => {
                onPress();
                expandButton();
            } },
            react_1.default.createElement(S.TitleWrapper, null,
                CardIcon ?? CardIcon,
                react_1.default.createElement(S.CardText, null, cardText)),
            react_1.default.createElement(react_native_1.Animated.View, { style: { transform: [{ rotate: spin }] } },
                react_1.default.createElement(Atoms_1.DownArrow, { color: dropDownIconColor }))),
        expanded && (react_1.default.createElement(S.ContentCardWrapper, { border: expanded },
            react_1.default.createElement(S.CardHeader, null, headerText),
            react_1.default.createElement(S.CardDescription, null, descriptionText)))));
};
